import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Button from 'Components/UI/Button';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useLogsContext } from '../LogsContext';

const useStyles = buildUseStyles('PaginationButtons', ((theme) => ({
  root: {
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
})));

const PaginationButtons = ({ collection }) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const classes = useStyles();
  const { loadLogsCollectionNext, loadLogsCollectionPrev } = useLogsContext();

  function onBackClick() {
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'event log pagination back button');
    loadLogsCollectionPrev();
  }

  function onNextClick() {
    logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'event log pagination next button');
    loadLogsCollectionNext();
  }

  return (
    <Box
      className={classes.root}
    >
      <Button
        color={'primary'}
        variant={'contained'}
        onClick={onBackClick}
        disabled={!collection.link('prev')}
        test={'facet-plan-log-prev-button'}
      >
            Previous
      </Button>
      <Button
        color={'primary'}
        variant={'contained'}
        onClick={onNextClick}
        disabled={!collection.link('next')}
        test={'facet-plan-log-next-button'}
      >
            Next
      </Button>
    </Box>
  );
};

PaginationButtons.defaultProps = {
};

PaginationButtons.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default PaginationButtons;
